<div class="color-picker-container">

  <div class="toolbar-container">
    <mode-color-toolbar
      [currentColor]="currentColor"
      [savedColor]="savedColor"
      (colorUpdated)="onToolbarColorUpdated($event)"
    ></mode-color-toolbar>
  </div>

  <div class="saturation-value-container">
    <mode-saturation-value
      [hue]="currentHue"
      [saturation]="currentSaturation"
      [value]="currentValue"
      [height]="126"
      [width]="196"
      (moveStart)="onMoveStart()"
      (moveEnd)="onMoveEnd()"
      (selectedColor)="onSaturationColorUpdated($event)"
    ></mode-saturation-value>
  </div>

  <mode-hue-selector
    [hue]="currentHue"
    [gradientWidth]="196"
    [gradientHeight]="12"
    (moveStart)="onMoveStart()"
    (moveEnd)="onMoveEnd()"
    (hueChanged)="onHueChange($event)"
  ></mode-hue-selector>
</div>